import React from "react";
import { FlexContainer } from "src/components";
import ColorPickerTrigger from "../components/ColorPickerTrigger";
import { TextLabel } from "../../style";

export const TextColorField = ({ value, isUpdate, onChange }) => {
 
    return (
        <FlexContainer>
            <TextLabel color="#000000" fontWeight="bold" fontSize="16px">
                Text Colour Picker
            </TextLabel>
            <TextLabel color="#612684" fontSize="15px">
                {isUpdate ? "Edit" : ""} Select colour
            </TextLabel>
            <ColorPickerTrigger
                color={value}
                onChange={(e) => onChange(e.hex)}
                isPreview={false}
                width="40px"
                height="40px"
            />
        </FlexContainer>
    );
};
